import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './BusinessPage.css';

const BusinessPage = () => {
    useEffect(() => {
        document.title = "Marlo - For Business";
    }, []);

    // 触发下载弹窗
    const handleTryFree = () => {
        window.dispatchEvent(new Event('openDownloadModal'));
    };

    // 打开Stripe付费链接
    const handleGetPro = () => {
        window.open('https://buy.stripe.com/bJe14ogA47l37UJdfg1ZS00', '_blank');
    };

    // 打开邮件客户端
    const handleEmailClick = () => {
        window.location.href = 'mailto:Hello@himarlo.com';
    };

    return (
        <div className="business-page">
            <Header />
            
            {/* 主要内容 */}
            <div className="business-content">
                {/* 背景图片 */}
                <div className="business-bg-header"></div>
                {/* 标题文字组 */}
                <div className="business-title-group">
                    <div className="business-title-line1">
                        Reach More.
                    </div>
                    <div className="business-title-line2">
                        Engage Better.
                    </div>
                    <div className="business-title-line3">
                        Host Smarter with
                    </div>
                    <div className="business-title-line4">
                        Marlo.
                    </div>
                </div>
                
                {/* 功能卡片组 */}
                <div className="business-cards-container">
                    {/* 第一个卡片 */}
                    <div className="business-card">
                        <div className="business-card-header">
                            <img 
                                src={require('../images/business/user.png')} 
                                alt="User" 
                                className="business-card-icon"
                            />
                            <span className="business-card-title">Grow Your Audience</span>
                        </div>
                        <div className="business-card-description">
                            Get instant local visibility and attract more attendees.
                        </div>
                    </div>
                    
                    {/* 分隔线 */}
                    <div className="business-divider"></div>
                    
                    {/* 第二个卡片 */}
                    <div className="business-card">
                        <div className="business-card-header">
                            <img 
                                src={require('../images/business/rocket.png')} 
                                alt="Rocket" 
                                className="business-card-icon"
                            />
                            <span className="business-card-title">Boost Engagement</span>
                        </div>
                        <div className="business-card-description">
                            Connect with participants through chatrooms, reminders, and social sharing.
                        </div>
                    </div>
                    
                    {/* 分隔线 */}
                    <div className="business-divider"></div>
                    
                    {/* 第三个卡片 */}
                    <div className="business-card">
                        <div className="business-card-header">
                            <img 
                                src={require('../images/business/flame.png')} 
                                alt="Flame" 
                                className="business-card-icon"
                            />
                            <span className="business-card-title">Maximize Event Success</span>
                        </div>
                        <div className="business-card-description">
                            Leverage AI tools, advanced targeting, and attendee insights for results that matter.
                        </div>
                    </div>
                </div>
                
                {/* 第二个模块 - 服务计划 */}
                <div className="business-service-section">
                    <div className="business-service-title">
                        Marlo Organizer<br />
                        Value-Added Service Plans
                    </div>
                </div>

                {/* Pad 端专用模块 - 服务计划 */}
                <div className="business-pad-service-section">
                    <div className="business-pad-service-title">
                        Marlo Organizer<br />
                        Value-Added Service Plans
                    </div>
                    
                    {/* 第一个卡片 - Free */}
                    <div className="business-pad-card business-pad-card-1">
                        <div className="card-title">Free</div>
                        <div className="card-subtitle">Perfect for first-time organizers exploring</div>
                        <div className="card-price">
                            <span className="price-amount">$0</span>
                            <span className="price-period">/month</span>
                        </div>
                        <button className="card-button card-button-pad" onClick={handleTryFree}>Try Free</button>
                        
                        <div className="card-features">
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Shown to users within a 4-mile radius</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Attendees can chat before & after the event</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Auto-generated, share-ready visuals for social media</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">See who's joining to plan and engage better</span>
                            </div>
                        </div>
                    </div>
                    
                    {/* 第二个卡片 - Pro */}
                    <div className="business-pad-card business-pad-card-2">
                        <div className="card-title">Pro</div>
                        <div className="card-subtitle card-subtitle-pro">For organizers seeking national reach & city-based discovery</div>
                        <div className="card-price">
                            <span className="price-amount">$39.99</span>
                            <span className="price-period">/month</span>
                        </div>
                        <button className="card-button card-button-pro card-button-pad" onClick={handleGetPro}>Get Pro</button>
                        
                        <div className="card-star-section">
                            <div className="star-row">
                                <img 
                                    src={require('../images/business/star.png')} 
                                    alt="Star" 
                                    className="star-icon"
                                />
                                <span className="star-text">Everything in Free and:</span>
                            </div>
                            <div className="card-divider"></div>
                        </div>
                        
                        <div className="card-features">
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Visible to users across the U.S.</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Enable ticket payments and collect fees directly</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Auto-featured in Nearby feed, 4-mile reach, visibility grows as more join</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Persistent chatroom with 5 admins for member management</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Organizer platform to showcase your brand, event data, and links.</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* 第三个模块 - 带背景的卡片组 */}
                <div className="business-card-section">
                    <div className="business-card-group">
                        {/* Free卡片 */}
                        <div className="business-white-card">
                            <div className="card-title">Free</div>
                            <div className="card-subtitle">Perfect for first-time organizers exploring</div>
                            <div className="card-price">
                                <span className="price-amount">$0</span>
                                <span className="price-period">/month</span>
                            </div>
                            <button className="card-button" onClick={handleTryFree}>Try Free</button>
                            
                            <div className="card-features">
                                <div className="feature-item">
                                    <img 
                                        src={require('../images/business/yes.png')} 
                                        alt="Yes" 
                                        className="feature-icon"
                                    />
                                    <span className="feature-text">Shown to users within a 4-mile radius</span>
                                </div>
                                <div className="feature-item">
                                    <img 
                                        src={require('../images/business/yes.png')} 
                                        alt="Yes" 
                                        className="feature-icon"
                                    />
                                    <span className="feature-text">Attendees can chat before & after the event</span>
                                </div>
                                <div className="feature-item">
                                    <img 
                                        src={require('../images/business/yes.png')} 
                                        alt="Yes" 
                                        className="feature-icon"
                                    />
                                    <span className="feature-text">Auto-generated, share-ready visuals for social media</span>
                                </div>
                                <div className="feature-item">
                                    <img 
                                        src={require('../images/business/yes.png')} 
                                        alt="Yes" 
                                        className="feature-icon"
                                    />
                                    <span className="feature-text">See who's joining to plan and engage better</span>
                                </div>
                            </div>
                        </div>
                        
                        {/* Pro卡片 */}
                        <div className="business-white-card">
                            <div className="card-title">Pro</div>
                            <div className="card-subtitle card-subtitle-pro">For organizers seeking national reach & city-based discovery</div>
                            <div className="card-price">
                                <span className="price-amount">$39.99</span>
                                <span className="price-period">/month</span>
                            </div>
                            <button className="card-button card-button-pro" onClick={handleGetPro}>Get Pro</button>
                            
                            <div className="card-star-section">
                                <div className="star-row">
                                    <img 
                                        src={require('../images/business/star.png')} 
                                        alt="Star" 
                                        className="star-icon"
                                    />
                                    <span className="star-text">Everything in Free and:</span>
                                </div>
                                <div className="card-divider"></div>
                            </div>
                            
                            <div className="card-features">
                                <div className="feature-item">
                                    <img 
                                        src={require('../images/business/yes.png')} 
                                        alt="Yes" 
                                        className="feature-icon"
                                    />
                                    <span className="feature-text">Visible to users across the U.S.</span>
                                </div>
                                <div className="feature-item">
                                    <img 
                                        src={require('../images/business/yes.png')} 
                                        alt="Yes" 
                                        className="feature-icon"
                                    />
                                    <span className="feature-text">Enable ticket payments and collect fees directly</span>
                                </div>
                                <div className="feature-item">
                                    <img 
                                        src={require('../images/business/yes.png')} 
                                        alt="Yes" 
                                        className="feature-icon"
                                    />
                                    <div className="feature-text">
                                        Auto-featured in Nearby feed, 4-mile reach, visibility<br />
                                        grows as more join <span className="qa-icon-container">
                                            <img 
                                                src={require('../images/business/qa.png')} 
                                                alt="QA" 
                                                className="qa-icon"
                                            />
                                            <div className="qa-tooltip">
                                                <div className="qa-tooltip-arrow"></div>
                                                <div className="qa-tooltip-content">
                                                    <div className="qa-tooltip-text">
                                                        Your event is auto-featured in the Nearby feed when someone clicks "I'm in," reaching users within 4 miles. As more join, visibility expands—driving viral growth.
                                                    </div>
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <img 
                                        src={require('../images/business/yes.png')} 
                                        alt="Yes" 
                                        className="feature-icon"
                                    />
                                    <span className="feature-text">Persistent chatroom with 5 admins for member management</span>
                                </div>
                                <div className="feature-item">
                                    <img 
                                        src={require('../images/business/yes.png')} 
                                        alt="Yes" 
                                        className="feature-icon"
                                    />
                                    <span className="feature-text">Organizer platform to showcase your brand, event data, and links.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 手机端专用模块 - 服务计划 */}
                <div className="business-mobile-service-section">
                    <div className="business-mobile-service-title">
                        Marlo Organizer<br />
                        Value-Added Service Plans
                    </div>
                    
                    {/* 第一个卡片 - Free */}
                    <div className="business-mobile-card business-mobile-card-1">
                        <div className="card-title">Free</div>
                        <div className="card-subtitle">Perfect for first-time organizers exploring</div>
                        <div className="card-price">
                            <span className="price-amount">$0</span>
                            <span className="price-period">/month</span>
                        </div>
                        <button className="card-button card-button-mobile" onClick={handleTryFree}>Try Free</button>
                        
                        <div className="card-features">
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Shown to users within a 4-mile radius</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Attendees can chat before & after the event</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Auto-generated, share-ready visuals for social media</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">See who's joining to plan and engage better</span>
                            </div>
                        </div>
                    </div>
                    
                    {/* 第二个卡片 - Pro */}
                    <div className="business-mobile-card business-mobile-card-2">
                        <div className="card-title">Pro</div>
                        <div className="card-subtitle card-subtitle-pro">For organizers seeking national reach & city-based discovery</div>
                        <div className="card-price">
                            <span className="price-amount">$39.99</span>
                            <span className="price-period">/month</span>
                        </div>
                        <button className="card-button card-button-pro card-button-mobile" onClick={handleGetPro}>Get Pro</button>
                        
                        <div className="card-star-section">
                            <div className="star-row">
                                <img 
                                    src={require('../images/business/star.png')} 
                                    alt="Star" 
                                    className="star-icon"
                                />
                                <span className="star-text">Everything in Free and:</span>
                            </div>
                            <div className="card-divider"></div>
                        </div>
                        
                        <div className="card-features">
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Visible to users across the U.S.</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Enable ticket payments and collect fees directly</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Your event is auto-featured in the Nearby feed when someone clicks "I'm in," reaching users within 4 miles. As more join, visibility expands—driving viral growth.</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Persistent chatroom with 5 admins for member management</span>
                            </div>
                            <div className="feature-item">
                                <img 
                                    src={require('../images/business/yes_pad.png')} 
                                    alt="Yes" 
                                    className="feature-icon"
                                />
                                <span className="feature-text">Organizer platform to showcase your brand, event data, and links.</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* 第四个模块 - 联系我们 */}
                <div className="business-contact-section">
                    {/* 光晕效果组 */}
                    <div className="contact-glow-group">
                        {/* 蓝色光晕 */}
                        <div className="contact-glow-blue"></div>
                        {/* 绿色光晕 */}
                        <div className="contact-glow-green"></div>
                    </div>
                    
                    {/* 主要文字 */}
                    <div className="contact-main-text">
                        Ready to promote your <br />event on Marlo Explore?
                    </div>
                    
                    {/* 手机端主要文字 */}
                    <div className="contact-main-text-mobile">
                        Ready to promote<br />
                        your event on Marlo<br />
                        Explore?
                    </div>
                    
                    {/* 邮箱文字 */}
                    <div className="contact-email-text">
                        Email us <span className="email-highlight-container" onClick={handleEmailClick} style={{ cursor: 'pointer' }}>
                            <span className="email-highlight">Hello@himarlo.com</span>
                            <span className="email-underline"></span>
                        </span>
                    </div>
                </div>
            </div>
            
            <Footer />
        </div>
    );
};

export default BusinessPage;
